import { service } from '@ember/service';
import { Ability } from 'ember-can';
import EntryModel from 'garaje/models/entry';
import InviteModel from 'garaje/models/invite';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

import type { GetCanReviewOrReadBlocklistMatchModel } from './security';

// Gates review of policy-routed (AVA) approval tasks. Distinct from the legacy
// "requires approval" flow gated by ApprovalRequiredInviteAbility.
export default class AvaApprovalAbility extends Ability {
  declare model?: GetCanReviewOrReadBlocklistMatchModel;

  @service declare authz: AuthzService;

  get canReview(): boolean {
    const { parent } = this.model ?? {};

    if (parent instanceof EntryModel) return this.canReviewAnEntryApproval;
    if (parent instanceof InviteModel) return this.canReviewAnInviteApproval;

    return this.canReviewAnInviteApproval || this.canReviewAnEntryApproval;
  }

  get canReviewAnEntryApproval(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_ENTRY_AVA_APPROVAL_REVIEW);
  }

  get canReviewAnInviteApproval(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_INVITE_AVA_APPROVAL_REVIEW);
  }
}
